import { render, staticRenderFns } from "./PhoneBtn.vue?vue&type=template&id=86ec8a12&scoped=true"
import script from "./PhoneBtn.vue?vue&type=script&lang=js"
export * from "./PhoneBtn.vue?vue&type=script&lang=js"
import style0 from "./PhoneBtn.vue?vue&type=style&index=0&id=86ec8a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ec8a12",
  null
  
)

export default component.exports